export default () => {
  if ($('body.source-documents.index').length === 0) return

  const $form = $('form.documents-filter')
  $form.on('change', () => $form.submit())
}
